module.exports = __webpack_public_path__ + "img/91.b061ea86.jpg";